(() => {
  document.querySelectorAll('[data-hs-accordion]').forEach((accordion) => {
    accordion.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        accordion.querySelectorAll('details').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });
  });

  document.querySelectorAll('[data-hs-product]').forEach((root) => {
    const form = root.querySelector('[data-hs-form]');
    if (!form) return;
    const configNode = root.querySelector('[data-hs-config]');
    const config = configNode ? JSON.parse(configNode.textContent) : { directCheckout: true, root: '/', currency: 'USD' };
    const productNode = root.querySelector('[data-hs-product-json]');
    const variantInput = form.querySelector('[data-hs-variant-id]');
    const variantSelect = form.querySelector('[data-hs-variant-select]');
    const price = root.querySelector('[data-hs-price]');
    const compare = root.querySelector('[data-hs-compare]');
    const compareWrap = root.querySelector('[data-hs-compare-wrap]');
    const submit = root.querySelector('[data-hs-submit]');
    const submitLabel = root.querySelector('[data-hs-submit-label]');
    const error = root.querySelector('[data-hs-error]');
    const compareByVariant = new Map();

    const money = (cents) => {
      if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(Number(cents));
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: config.currency }).format(Number(cents) / 100);
    };

    const renderComparePrice = (comparePrice, currentPrice = Number(price?.dataset.price || 0)) => {
      if (!compare || !compareWrap) return;
      if (Number(comparePrice) > Number(currentPrice)) {
        compare.textContent = money(comparePrice);
        compareWrap.hidden = false;
      } else {
        compare.textContent = '';
        compareWrap.hidden = true;
      }
    };

    const applyProductData = (productData, multiplier = 1) => {
      (productData?.variants || []).forEach((variant) => {
        compareByVariant.set(String(variant.id), Math.round(Number(variant.compare_at_price || 0) * multiplier));
      });
      const selectedCompare = compareByVariant.get(String(variantInput.value)) || Math.round(Number(productData?.compare_at_price || productData?.compare_at_price_max || 0) * multiplier);
      const selectedPrice = Math.round(Number(productData?.variants?.find((variant) => String(variant.id) === String(variantInput.value))?.price || 0) * multiplier);
      if (selectedCompare > selectedPrice) renderComparePrice(selectedCompare, selectedPrice);
      return selectedCompare;
    };

    const hydrateComparePrices = async () => {
      if (!config.productHandle || !compare || !compareWrap) return;
      if (productNode) {
        try {
          const embeddedProduct = JSON.parse(productNode.textContent);
          if (applyProductData(embeddedProduct) > 0) return;
        } catch (_issue) {
          // Fall through to Shopify's public product endpoint.
        }
      }
      try {
        const productUrl = `${config.root}products/${encodeURIComponent(config.productHandle)}.js?country=US`;
        const response = await fetch(productUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Shopify product JS endpoint unavailable');
        const productData = await response.json();
        if (applyProductData(productData) > 0) return;
      } catch (_issue) {
        // Try Shopify's alternate JSON endpoint below.
      }
      try {
        const productUrl = `${config.root}products/${encodeURIComponent(config.productHandle)}.json?country=US`;
        const response = await fetch(productUrl, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const payload = await response.json();
        applyProductData(payload.product, 100);
      } catch (_issue) {
        // Keep the server-rendered price when Shopify's JSON endpoints are unavailable.
      }
    };

    variantSelect?.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      variantInput.value = option.value;
      price.textContent = money(option.dataset.price);
      const comparePrice = Number(option.dataset.compare || 0) || compareByVariant.get(String(option.value)) || 0;
      renderComparePrice(comparePrice, Number(option.dataset.price || 0));
      const available = option.dataset.available === 'true';
      submit.disabled = !available;
      submitLabel.textContent = available ? 'GET YOURS 50% OFF' : 'SOLD OUT';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });

    hydrateComparePrices();

    form.addEventListener('submit', async (event) => {
      if (!config.directCheckout) return;
      event.preventDefault();
      if (!variantInput.value || submit.disabled) return;
      error.hidden = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submitLabel.textContent = 'ADDING…';
      try {
        const response = await fetch(`${config.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(variantInput.value), quantity: 1 })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'This selection could not be added.');
        window.location.assign(`${config.root}checkout`);
      } catch (issue) {
        error.textContent = issue.message || 'Something went wrong. Please try again.';
        error.hidden = false;
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        submitLabel.textContent = 'GET YOURS 50% OFF';
      }
    });
  });
})();
